<template>
  <div>
    <b-card header-tag="header" class="mb-3">
      <!-- 헤더 -->
      <div slot="header">
        <i class="fa fa-bars"></i> <strong>맵 타입</strong>
      </div>
      <!-- 바디 -->
      <div>
        <b-row class="mb-2">
          <b-col cols="12" class="float-right">
            <!-- 검색어 -->
            <div class="float-right">
              <b-button v-ripple variant="info" @click.stop="handleSearchClicked">
                <i class="fa fa-refresh"></i>
              </b-button>
              <b-button v-ripple variant="primary" @click.stop="handleAddClicked">
                <i class="fa fa-plus"></i>
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <!-- table -->
            <b-table outlined responsive no-local-sorting stacked="sm" :foot-clone="true" caption=" ▶︎ 맵타입ID는 데이터파일 이름 및 심볼릭링크 이름 자동 생성에 사용되므로 용도에 맞게 입력하세요."
                     :fields="fields"
                     :items="items">
              <!-- 맵타입 ID -->
              <template slot="mapTypeId" slot-scope="data">
                <b-form-input type="text" placeholder="정의된 영문 소문자로 입력" v-model="data.item.mapTypeId" :style="formBackgroundColor(data)" :readonly="formMapTypeIdReadOnly(data)" />
              </template>
              <!-- 이름 -->
              <template slot="mapTypeName" slot-scope="data">
                <b-form-input type="text" placeholder="맵타입명" v-model="data.item.mapTypeName" :style="formBackgroundColor(data)"/>
              </template>
              <!-- 비고 -->
              <template slot="description" slot-scope="data">
                <b-form-input type="text" placeholder="비고 내용" v-model="data.item.description" :style="formBackgroundColor(data)"/>
              </template>
              <!-- 액션 버튼 -->
              <template slot="action" slot-scope="data">
                <b-row>
                  <b-col class="text-right">
                    <b-button-group class="">
                      <b-button v-ripple variant="outline-primary" @click="handleSaveClicked(data)" class="mr-1">
                        <i class="fa fa-check"></i>
                      </b-button>
                      <b-button v-ripple variant="outline-danger" @click="handleDeleteClicked(data)">
                        <i class="fa fa-trash"></i>
                      </b-button>
                    </b-button-group>
                  </b-col>
                </b-row>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fields: [
        { key: 'mapTypeId', label: '맵타입ID' },
        { key: 'mapTypeName', label: '맵타입명' },
        { key: 'description', label: '비고' },
        { key: 'action', label: ' ' }
      ],
      items: []
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    // 맵타입 목록 조회
    fetchList () {
      this.$http.get('/setting/mapTypes')
        .then((response) => {
          this.$data.items = response.data.result.mapTypes
        })
        .catch((error) => {
          this.$toasted.global.error(this.formatErrorMessage(error))
        })
    },
    // 폼 입력필드 백그라운드 설정 - 신규 입력필드인 경우 노란색으로 디스플레이
    formBackgroundColor (data) {
      if (data.item.isNewItem) {
        return 'background-color:#fafad2;'
      } else {
        return null
      }
    },
    // 맵타입ID 읽기전용여부 설정
    formMapTypeIdReadOnly (data) {
      // 신규추가 버튼을 클릭하여 생성된 빈 데이터만 isNewItem 값이 true 임
      if (data.item.isNewItem) {
        return false
      } else {
        return true
      }
    },

    /**
     * <맵타입 관리> 화면 이벤트 처리 메소드
     */

    // 추가 버튼 클릭 시
    handleAddClicked () {
      // 입력 폼은 한건만 디스플레이 한다
      let find = false
      for (let idx in this.$data.items) {
        let item = this.$data.items[idx]
        if (item.isNewItem) {
          find = true
          break
        }
      }
      if (find) {
        this.$toasted.global.info('한건씩만 입력 가능합니다.')
        return false
      }
      // 빈 아이템 생성
      let emptyItem = {
        mapTypeId: null,
        mapTypeName: null,
        description: null,
        isNewItem: true
      }
      // 배열 맨 앞에 추가한다
      this.$data.items.unshift(emptyItem)
    },
    // 조회 버튼 클릭 시
    handleSearchClicked (e) {
      this.fetchList()
    },
    // 저장 버튼 클릭 시
    handleSaveClicked (data) {
      if (!data.item.mapTypeId) {
        this.$toasted.global.info('맵타입ID를 입력하세요.')
        return false
      }
      if (data.item.mapTypeId.length < 2) {
        this.$toasted.global.info('맵타입ID를 2자리 이상 입력하세요.')
        return false
      }
      if (data.item.mapTypeId.length > 20) {
        this.$toasted.global.info('맵타입ID를 20자리 이내로 입력하세요.')
        return false
      }
      if (!data.item.mapTypeName) {
        this.$toasted.global.info('맵타입명을 입력하세요.')
        return false
      }
      let url = '/setting/mapTypes/' + data.item.mapTypeId
      // 신규추가 버튼을 클릭하여 생성된 빈 데이터만 isNewItem 값이 true 임
      if (data.item.isNewItem) {
        this.$http.post(url, data.item)
          .then((response) => {
            this.$toasted.global.success('저장 되었습니다.')
            this.fetchList()
          })
          .catch((error) => {
            this.$toasted.global.error(this.formatErrorMessage(error))
          })
      } else {
        this.$http.put(url, data.item)
          .then((response) => {
            this.$toasted.global.success('저장 되었습니다.')
            this.fetchList()
          })
          .catch((error) => {
            this.$toasted.global.error(this.formatErrorMessage(error))
          })
      }
    },
    // 삭제 버튼 클릭 시
    handleDeleteClicked (data) {
      // 신규버튼을 눌러 디스플레이된 로우를 삭제하는 경우
      if (data.item.isNewItem) {
        for (let i = 0; i < this.$data.items.length; i++) {
          if (this.$data.items[i].isNewItem) {
            this.$data.items.splice(i, 1)
            break
          }
        }
        return false
      }
      // 실제 데이터를 삭제하는 경우
      let message = '현재 사용중인 맵타입은 삭제되지 않습니다. 정말로 ' + data.item.mapTypeName + '을(를) 삭제 하시겠습니까? '
      if (confirm(message)) {
        this.$http.delete('/setting/mapTypes/' + data.item.mapTypeId)
          .then((response) => {
            this.$toasted.global.success('삭제되었습니다.')
            this.fetchList()
          })
          .catch((error) => {
            this.$toasted.global.error(this.formatErrorMessage(error))
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/MapType.vue